import React, { useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  Card,
  CardContent,
  Grid,
  IconButton,
  useTheme,
  alpha,useMediaQuery,Theme
} from '@mui/material';
import {
  MapOutlined as MapOutlinedIcon,
  ViewList as ViewListIcon,
  Favorite as FavoriteIcon,
  Delete as DeleteIcon,
  Business as BusinessIcon,
  People as PeopleIcon,
  HelpOutline as HelpOutlineIcon,
  Upload as UploadIcon,
  Share as ShareIcon,
  NewReleases as NewReleasesIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import SideMenu from '../components/SideMenu';

interface MenuInfo {
  title: string;
  path: string;
  icon: React.ReactNode;
  description: string;
  isNew?: boolean;
}

const SiteMapPage = () => {
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const menus: MenuInfo[] = [
    {
      title: '일정 플랫폼',
      path: '/itinerary-share',
      icon: <ShareIcon />,
      description: '전세계 여행일정을 한눈에 확인하고 활용할 수 있는 B2B 플랫폼입니다. 랜드사, 여행사가 등록한 여행일정, 가격, 출발일, 관광지 정보를 검색하여 확인하고 내 일정표로 다운로드할 수 있습니다. 일정표 등록 회사의 연락처, 이메일, 주소 및 보증보험 가입 현황도 투명하게 제공됩니다. Ver 2.0에서는 업체와의 견적 요청, 실시간 채팅, 질의응답 기능이 추가될 예정입니다.'
    },
    {
      title: '내 일정표',
      path: '/itinerary-list',
      icon: <ViewListIcon />,
      description: '기존 엑셀 일정표를 클릭 한 번으로 스마트한 웹 일정표로 변환하세요. 도시, 장소 자동 매칭과 관광지 정보가 자동으로 등록되며, 거래처와 고객이 필요한 시점에 웹, HWP, XLS, PDF 형식으로 즉시 공유가 가능합니다. 일정 플랫폼에서 다운로드한 일정표도 수정하고 공유할 수 있으며, 타사 일정표도 자동으로 회사 로고, 연락처, 담당자 정보가 포함되어 전달됩니다. Ver 2.0에서는 보유한 일정표로 자동 홈페이지 구축 기능을 제공할 예정입니다.'
    },
    {
      title: '일정 등록',
      path: '/itinerary-upload',
      icon: <UploadIcon />,
      description: '엑셀 일정표를 드래그하거나 클릭하여 손쉽게 웹 일정표로 변환하세요. 대형 패키지 회사의 일정표처럼 상품명, 가격, 지역, 도시, 장소가 자동으로 매칭되어 풍부한 내용의 일정표로 재탄생됩니다. 변환된 웹 일정표는 즉시 편집기를 통해 수정이 가능합니다. Ver 2.0에서는 식당, 골프장, 관광지, 도시 정보를 직접 추가하여 나만의 특별한 일정표를 만들 수 있습니다.'
    },
    {
      title: '즐겨찾기',
      path: '/favorite',
      icon: <FavoriteIcon />,
      description: '자주 사용하는 일정표와 중요한 정보를 즐겨찾기에 등록하여 효율적으로 관리하세요. 자주 방문하는 도시의 관광지 정보, 주요 거래처의 일정표, 인기 있는 패키지 상품을 즐겨찾기에 추가하여 클릭 한 번으로 빠르게 접근할 수 있습니다. 등록된 즐겨찾기는 카테고리별로 구분하여 체계적으로 관리할 수 있으며, 중요도에 따라 순서를 자유롭게 변경할 수 있습니다.'
    },
    {
      title: '휴지통',
      path: '/itinerary-recycle',
      icon: <DeleteIcon />,
      description: '실수로 삭제한 일정표나 정보를 안전하게 복구할 수 있는 공간입니다. 삭제된 항목은 30일간 휴지통에 보관되며, 이 기간 동안 언제든지 복구가 가능합니다. 복구 시 연관된 모든 정보(관광지 정보, 가격, 일정 등)가 함께 복원되어 데이터 손실 걱정이 없습니다. 또한 더 이상 필요하지 않은 항목은 영구 삭제하여 저장 공간을 효율적으로 관리할 수 있습니다.'
    },
    {
      title: '회사 정보',
      path: '/company-info',
      icon: <BusinessIcon />,
      description: '회사의 핵심 정보를 한눈에 확인하고 관리할 수 있는 공간입니다. 회사 로고, 상호, 대표자명, 사업자등록번호부터 연락처, 이메일, 주소까지 모든 정보를 체계적으로 관리할 수 있습니다. 등록된 정보는 일정표 공유 시 자동으로 반영되며, 보증보험 정보와 사업자 인증 현황도 함께 관리됩니다. 회사 정보는 일정플랫폼에서 자사를 홍보하고 신뢰를 주기 위한 가장 중요한 홍보 수단입니다.'
    },
    {
      title: '직원 관리',
      path: '/employee-management',
      icon: <PeopleIcon />,
      description: '직원 정보와 권한을 효율적으로 관리할 수 있는 시스템입니다. 직원별로 맞춤 권한을 설정하여 일정표 조회, 수정, 삭제, 공유 권한을 세밀하게 제어할 수 있습니다. 부서별, 직급별로 직원을 구분하여 관리할 수 있으며, 각 직원의 담당 업무와 실적도 체계적으로 기록할 수 있습니다. 퇴사자 관리와 인수인계 기록도 안전하게 보관됩니다.'
    },
    {
      title: '시스템 문의',
      path: '/system-inquiry',
      icon: <HelpOutlineIcon />,
      description: '시스템 사용 중 발생하는 모든 문의사항을 실시간으로 해결해드립니다. 카카오톡 채널을 통해 빠르고 정확한 답변을 받을 수 있으며, 시스템 개선 요청이나 새로운 기능 제안도 가능합니다. 문의 내용은 카테고리별로 분류되어 관리되며, 자주 묻는 질문과 답변도 체계적으로 정리되어 있습니다.'
    },
    {
      title: 'Version 2.0 Preview',
      path: '/version2-preview',
      icon: <NewReleasesIcon />,
      description: '곧 출시될 Version 2.0의 혁신적인 기능을 안내합니다. 클릭 몇 번으로 완성되는 맞춤형 홈페이지 제작 관리, 온/오프라인 통합 상담 예약 시스템, 실시간 채팅 상담 등 더욱 강력해진 기능들이 준비되어 있습니다. 일정 관리부터 홈페이지 운영, 고객 관리까지 올인원 솔루션으로 비즈니스의 새로운 차원을 경험하실 수 있습니다.',
      isNew: true
    }
  ];

  return (
    <Box sx={{ display: 'flex' }}>
      <SideMenu mobileOpen={mobileOpen} handleDrawerToggle={handleDrawerToggle} />
      <Box sx={{ flexGrow: 1, p: 3 }}>
        <Box sx={{ maxWidth: '1200px', margin: '0 auto' }}>
          <Paper elevation={0} sx={{ p: 2, mb: 3 }}>
            <Box sx={{ ...(isMobile ? { p: 0, mt: 3 } : { p: 0, m: 2 }), display: 'flex', alignItems: 'center', gap: 1 }}>
              <IconButton size="small" sx={{ backgroundColor: 'primary.main', color: 'white' }}>
                <MapOutlinedIcon />
              </IconButton>
              <Typography variant="h6" component="h1">
                사이트맵
              </Typography>
            </Box>
          </Paper>

          <Grid container spacing={3} sx={{ height: '800px' }}>
            {menus.map((menu) => (
              <Grid item xs={12} sm={6} md={4} key={menu.path}>
                <Card 
                  sx={{ 
                    height: '100%', 
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    position: 'relative',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: theme.shadows[8]
                    }
                  }}
                  onClick={() => navigate(menu.path)}
                >
                  {menu.isNew && (
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 16,
                        right: 16,
                        backgroundColor: theme.palette.warning.main,
                        color: theme.palette.warning.contrastText,
                        borderRadius: '12px',
                        px: 1,
                        py: 0.5,
                        fontSize: '0.75rem',
                        fontWeight: 'bold',
                      }}
                    >
                      Coming Soon
                    </Box>
                  )}
                  <CardContent >
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 1 }}>
                      <IconButton 
                        size="small" 
                        sx={{ 
                          backgroundColor: menu.isNew 
                            ? alpha(theme.palette.warning.main, 0.1)
                            : alpha(theme.palette.primary.main, 0.1),
                          color: menu.isNew 
                            ? theme.palette.warning.main
                            : theme.palette.primary.main
                        }}
                      >
                        {menu.icon}
                      </IconButton>
                      <Typography variant="h6" component="h2">
                        {menu.title}
                      </Typography>
                    </Box>
                    <Typography 
                      variant="body2" 
                      color="text.secondary"
                      sx={{ 
                        lineHeight: 1.6,
                        display: '-webkit-box',
                        WebkitLineClamp: 4,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden'
                      }}
                    >
                      {menu.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default SiteMapPage;
